import { DropdownSort } from '@/shared-components/dropdown';

export default function PaymentFilter({ value, options, onChange }) {
  return (
    <div className="profile-payments__filter">
      <DropdownSort
        defaultOption={value}
        options={options}
        onChangeOption={onChange}
      />
    </div>
  );
}
